import moment from 'moment'

export default (value) => moment(String(value)).format()

